module.exports = __webpack_public_path__ + "img/dashboard-colored.fc44d7cd.svg";